(() => {
  'use strict';
  if (window.mmProductConversion) return;
  window.mmProductConversion = true;
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const normalized = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const priceFromLabel = input => {
    const label = input.closest('label');
    const price = label?.querySelector('.tpo_additional-price');
    if (!price) return 0;
    const value = price.textContent.replace(/\s/g, '').match(/-?\d+(?:[.,]\d{1,2})?/);
    return value ? Math.round(Number(value[0].replace(',', '.')) * 100) : 0;
  };
  function initialize(root = document) {
    root.querySelectorAll('[data-mm-conversion]').forEach(panel => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      const info = panel.closest('.product__info-container');
      if (!info) return;
      const variants = JSON.parse(panel.querySelector('[data-mm-variants]').textContent);
      const copy = JSON.parse(panel.querySelector('[data-mm-copy]').textContent);
      const money = new Intl.NumberFormat(copy.locale, { style: 'currency', currency: copy.currency });
      const form = document.getElementById(panel.dataset.form);
      const mainButton = form?.querySelector('[name="add"]');
      if (!form || !mainButton) return;
      let property = form.querySelector('[data-mm-readable-summary]');
      if (!property) {
        property = document.createElement('input');
        property.type = 'hidden';
        property.name = 'properties[_mm_personnalisation]';
        property.dataset.mmReadableSummary = '';
        property.disabled = true;
        form.append(property);
      }
      const totalBox = panel.querySelector('.mm-conversion-total');
      const totalOutput = panel.querySelector('[data-mm-total]');
      const summaryOutput = panel.querySelector('[data-mm-summary]');
      const sticky = document.createElement('div');
      sticky.className = 'mm-conversion-sticky';
      sticky.hidden = true;
      const stickyPrice = document.createElement('strong');
      const stickyButton = document.createElement('button');
      stickyButton.type = 'button';
      stickyButton.textContent = copy.choose;
      sticky.append(stickyPrice, stickyButton);
      document.body.append(sticky);
      let lastTotal = 0;
      let pending = false;
      function update() {
        if (!panel.isConnected) { sticky.remove(); observer.disconnect(); return; }
        const id = form.querySelector('[name="id"]')?.value;
        const variant = variants.find(item => String(item.id) === id) || variants[0];
        if (!variant) return;
        const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || document.querySelector(`input[name="quantity"][form="${form.id}"]`)?.value || 1));
        const choices = [...info.querySelectorAll('.tpo_option-set-container input.tpo-checkbox-button:checked')].filter(input => !input.disabled);
        const names = choices.map(input => {
          const label = input.closest('label')?.querySelector('.tpo_option_type_label');
          return (label?.childNodes[0]?.textContent || input.value).replace(/\[.*?\]/g,'').replace(/\+\s*\d.*$/,'').trim();
        });
        const nameInput = [...info.querySelectorAll('input.tpo_text-box, textarea.tpo_text-box')].find(input => /prenom.*broder|name.*embroider/.test(normalized(input.name + ' ' + input.id)));
        const selectedColor = [...info.querySelectorAll('.tpo_option-container')].find(field => /couleur du fil|thread colou?r/.test(normalized(field.querySelector('.tpo_option-label-container')?.textContent)));
        const colorInput = selectedColor?.querySelector('input[type="radio"]:checked');
        const color = colorInput?.value.trim() || '';
        const details = [...names];
        if (choices.length && nameInput?.value.trim()) details.push(`${copy.name} : ${nameInput.value.trim()}`);
        if (choices.length && color) details.push(`${copy.thread} : ${color}`);
        lastTotal = (variant.price + choices.reduce((sum,input) => sum + priceFromLabel(input),0)) * quantity;
        text(totalOutput,money.format(lastTotal / 100));
        text(summaryOutput,details.join(' · '));
        totalBox.hidden = choices.length === 0;
        const disableProperty = choices.length === 0;
        if (property.disabled !== disableProperty) property.disabled = disableProperty;
        const propertyValue = choices.length ? details.join(' · ') : '';
        if (property.value !== propertyValue) property.value = propertyValue;
        text(stickyPrice,money.format(lastTotal / 100));
        stickyButton.disabled = mainButton.disabled;
        updateSticky();
      }
      function updateSticky() {
        if (!panel.isConnected) { sticky.remove(); return; }
        const rect = mainButton.getBoundingClientRect();
        const cart = document.querySelector('cart-drawer');
        const galleryModal = document.querySelector('dialog[open], .popup.active');
        sticky.hidden = rect.bottom > 0 || Boolean(cart?.classList.contains('active')) || Boolean(galleryModal) || !window.matchMedia('(max-width:749px)').matches;
      }
      stickyButton.addEventListener('click', () => {
        const options = info.querySelector('.tpo_option-set-container') || info.querySelector('variant-radios, variant-selects') || mainButton;
        options.scrollIntoView({ block:'center', behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
        mainButton.focus({ preventScroll:true });
      });
      const queue = () => { if (!pending) { pending = true; requestAnimationFrame(() => { pending=false;update(); }); } };
      const observer = new MutationObserver(queue);
      observer.observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','value','disabled','class']});
      info.addEventListener('change',queue);
      info.addEventListener('input',queue);
      form.addEventListener('submit',update,true);
      window.addEventListener('scroll',updateSticky,{passive:true});
      window.addEventListener('resize',updateSticky,{passive:true});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
